import React from 'react';

const Hero = () => {
  return (
    <header className="text-center mb-10 pt-6">
      <div className="inline-block bg-teal-50 text-teal-800 px-4 py-1.5 rounded-full text-sm font-semibold tracking-wide mb-6 uppercase">
        Personal Review
      </div>
      <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-slate-900 leading-tight mb-6">
        Tired of feeling drained by mid-afternoon after 35?
      </h1>
      <p className="text-xl sm:text-2xl text-slate-600 font-medium leading-relaxed max-w-2xl mx-auto">
        My review of the plant-based capsule that helped me support steady energy levels.
      </p>
      <div className="mt-8 flex items-center justify-center gap-4 text-sm text-slate-500">
        <img 
          src="https://media-manager-c.questera.ai/greta-media/bf058984a4ffdbb1bcf737e98ba89b4a0e9a3794368100afc61d724fc2136ffb549bddff932effd18582b107d1ceb382/images/aW1hZ2UvcG5n/872375181754af52fd842d05d30c2031.png" 
          alt="Sarah" 
          className="w-12 h-12 rounded-full object-cover object-top border-2 border-teal-100" 
        />
        <div className="text-left">
          <p className="font-semibold text-slate-800">By Sarah M.</p>
          <p>Updated Today • 3 min read</p>
        </div>
      </div>
    </header>
  );
};

export default Hero;